import React, { ReactNode, createContext } from 'react';

const defaultDirection = 'ltr';
const DirectionContext = createContext<'ltr' | 'rtl'>(defaultDirection);

export interface DirectionProviderProps {
    children: ReactNode;
    direction: 'ltr' | 'rtl';
}

const DirectionProvider = ({ children, direction }: DirectionProviderProps) => {
  return (
    <DirectionContext.Provider value={direction}>
      {children}
    </DirectionContext.Provider>
  );
};

export { DirectionContext, DirectionProvider };
